import memoize from 'transmute/memoize';
import { buildSenderLocator } from './buildSenderLocator';
export const isSenderPresent = memoize((senderId, senderType, presentSenderLocators) => {
  return Boolean(senderType) && presentSenderLocators.has(buildSenderLocator(senderType, senderId));
});